"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotherRoomSummary = MotherRoomSummary;
var jsx_runtime_1 = require("react/jsx-runtime");
var chart_colors_1 = require("../../../constants/chart-colors");
var tasks_1 = require("../tasks");
var clone_activity_chart_1 = require("./clone-activity-chart");
var mother_room_bar_chart_1 = require("./mother-room-bar-chart");
function MotherRoomSummary(props) {
    var _a, _b;
    var summary = props.summary;
    var taskStatusCounts = summary.taskStatusCounts;
    var STATUS_COLORS = {
        ACTIVE: chart_colors_1.CHART_COLORS.good,
        REGENERATION: chart_colors_1.CHART_COLORS.blue,
        BACKUP: chart_colors_1.CHART_COLORS.neutral,
        QUARANTINE: chart_colors_1.CHART_COLORS.warning,
        RETIRED: chart_colors_1.CHART_COLORS.orange,
        REMOVED: chart_colors_1.CHART_COLORS.critical,
    };
    var DESTINATION_COLORS = {
        NEW_MOTHER: chart_colors_1.CHART_COLORS.blue,
        PRODUCTION: chart_colors_1.CHART_COLORS.good,
        DISCARD: chart_colors_1.CHART_COLORS.critical,
    };
    var GENETICS_COLORS = [chart_colors_1.CHART_COLORS.blue, chart_colors_1.CHART_COLORS.green, chart_colors_1.CHART_COLORS.magenta, chart_colors_1.CHART_COLORS.yellow, chart_colors_1.CHART_COLORS.aqua, chart_colors_1.CHART_COLORS.orange];
    var totalMothers = summary.statusBreakdown.reduce(function (total, entry) { return total + entry.count; }, 0);
    var activeMothers = (_b = (_a = summary.statusBreakdown.find(function (entry) { return entry.status === "ACTIVE"; })) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0;
    var totalCloneBatches = summary.geneticsBreakdown.reduce(function (total, entry) { return total + entry.cloneBatchCount; }, 0);
    var statTiles = __spreadArray([
        { label: "Total Mother Plants", value: String(totalMothers), icon: "mdi:flower-outline", tone: "primary" },
        { label: "Active Mothers", value: String(activeMothers), icon: "solar:leaf-linear", tone: "success" },
        { label: "Clone Batches", value: String(totalCloneBatches), icon: "mdi:sprout-outline", tone: "info" }
    ], (taskStatusCounts ? [{ label: "Mother Tasks", value: String(taskStatusCounts.total), icon: "solar:checklist-linear", tone: "accent" }] : []), true);
    var cloneActivity = summary.cloneActivityTimeline.map(function (point) { return ({
        date: new Date(point.timestamp).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        cuttingsTaken: point.cuttingsTaken,
        clonesAllocated: point.clonesAllocated,
    }); });
    var destinations = summary.destinationBreakdown.map(function (entry) {
        var _a;
        return ({
            name: entry.destination,
            value: entry.quantity,
            color: (_a = DESTINATION_COLORS[entry.destination]) !== null && _a !== void 0 ? _a : chart_colors_1.CHART_COLORS.neutral,
        });
    });
    var statuses = summary.statusBreakdown.map(function (entry) {
        var _a;
        return ({
            name: entry.status,
            value: entry.count,
            color: (_a = STATUS_COLORS[entry.status]) !== null && _a !== void 0 ? _a : chart_colors_1.CHART_COLORS.neutral,
        });
    });
    var genetics = summary.geneticsBreakdown.map(function (entry, index) { return ({
        name: entry.genetics,
        value: entry.motherCount,
        color: GENETICS_COLORS[index % GENETICS_COLORS.length],
    }); });
    var tasks = taskStatusCounts
        ? [
            { name: "Completed", value: taskStatusCounts.completed, color: chart_colors_1.CHART_COLORS.good },
            { name: "Open", value: taskStatusCounts.open, color: chart_colors_1.CHART_COLORS.warning },
            { name: "Overdue", value: taskStatusCounts.overdue, color: chart_colors_1.CHART_COLORS.critical },
        ]
        : [];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(tasks_1.StatTileGrid, { tiles: statTiles }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-4", children: [(0, jsx_runtime_1.jsx)(clone_activity_chart_1.CloneActivityChart, { data: cloneActivity }), (0, jsx_runtime_1.jsx)(mother_room_bar_chart_1.MotherRoomBarChart, { title: "Clone Destinations", data: destinations })] }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-4 ".concat(taskStatusCounts ? "lg:grid-cols-3" : "lg:grid-cols-2"), children: [(0, jsx_runtime_1.jsx)(tasks_1.TaskStatusDonutChart, { title: "Mother Plants by Status", data: statuses, centerLabel: "Mothers" }), (0, jsx_runtime_1.jsx)(mother_room_bar_chart_1.MotherRoomBarChart, { title: "Mother Plants by Genetics", data: genetics }), taskStatusCounts && (0, jsx_runtime_1.jsx)(tasks_1.TaskStatusDonutChart, { title: "Mother Tasks", data: tasks, centerLabel: "Tasks" })] })] }));
}
